
 function reinitializeSlick() {
    let $slider = $('.wrap_upsell');
    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick'); 
    }
    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
        let i = (currentSlide ? currentSlide : 0) + 1;
        $('.counter_upsell').text(i + '/' + slick.slideCount);
    });
    $slider.slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
    });
    $('.previous_btn_upsell').on('click', function () {
      $slider.slick('slickPrev');
    });
    $('.next_btn_upsell').on('click', function () {
      $slider.slick('slickNext');
    });
  }
  reinitializeSlick();
  
      function updateqty(number, id) {
        let input = document.getElementById(id);
        let currentValue = parseInt(input.value) || 0;
            number = parseInt(number);
        let newValue = currentValue + number;
        if (newValue < 1) {
          newValue = 1;
        }
        input.value = newValue;
      }
   function reinitializeVariant() {    
          $('.cuurent_select_op').on('change', function () {
              let selected = $(this).find('option:selected');
              let price = selected.attr('price');
              let pid = selected.attr('Pid');
            $(`#variant__price__${pid}`).text(price);
          });
   }


function freeGiftInitialize() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(res => res.json())
    .then(parsedState => {
      window.discountSettings.cartTotal = parsedState.items_subtotal_price; 
      let includeVariant = false;
      let giftKey = "";
      let isGift = false;
      window.discountSettings.isGiftpresent = false;

      const alreadyInCart = parsedState.items.some(
        (item) => item.variant_id == window.discountSettings.giftProduct
      );
      parsedState.items.forEach(item => {
        if (window.discountSettings.variantsList.indexOf(item.id) > -1) {
          includeVariant = true;
        }

        if (item.properties && item.properties["_isGift"] === "Yes") {
          isGift = true;
        }

        if (item.id === window.discountSettings.giftProduct) {
          giftKey = item.key;
          window.discountSettings.isGiftpresent = true;
          window.discountSettings.cartTotal -= item.final_line_price;
        }
      });

      if (!alreadyInCart) {
        includeVariant = true;
      }

      if (window.discountSettings.enable) {
        if (
          includeVariant &&
          window.discountSettings.cartTotal >= window.discountSettings.minimumCartAmount &&
          window.discountSettings.isGiftpresent === false
        ) {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: window.discountSettings.giftProduct,
                  quantity: 1,
                  properties: { _isGift: 'Yes' },
                },
              ],
            }),
          })
            .then(res => res.json())
            .then(() => {
              window.discountSettings.isGiftpresent = true;
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
            })
            .catch(err => {
              console.error('Gift add failed:', err);
            });

        } else if (isGift) {
          if (
            !includeVariant ||
            window.discountSettings.cartTotal < window.discountSettings.minimumCartAmount
          ) {
            window.discountSettings.isGiftpresent = false;

            var formRemoveData = { id: giftKey, quantity: 0 };

            $.post({
              url: theme.routes.cart_change_url + '.js',
              data: JSON.stringify(formRemoveData),
              contentType: 'application/json',
              dataType: 'json'
            })
            .done(() => {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
            });
          }
        }
      }
    })
    .catch(err => console.error('Cart update failed:', err));
}


   reinitializeVariant();
    function addToCartVariant(id,vId) {
      let varId = $(`#product_variant__${id}`).val();
      let inputQty = $(`#qty-val-${id}`).val();
      
      if(!varId){
        varId = vId;
      } 
      if(!inputQty){
       inputQty = 1;
      }
      let formData = {
        id: varId,
        quantity: inputQty,
      };
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add',
        type: 'POST',
        data: formData,
        success: function (response) {
          $.ajax({
            url: window.Shopify.routes.root + '?section_id=cart-drawer',
            type: 'GET',
            dataType: 'html',
            success: function (carthtml) {
              $('cart-drawer').html($(carthtml).find('cart-drawer').html());
               bulletinBoard();
               reinitializeSlick();
               reinitializeVariant();
               freeGiftInitialize();
            },
          });
        },
      });
    }
    
        function bulletinBoard(){
          const sectionId = $('#cust-bulletin-board').data('section-id');
          $.ajax({
            url: window.location.pathname + '?section_id=' + sectionId,
            type: 'GET',
            dataType: 'html',
            success: function(sectionHtml){
              const content = $(sectionHtml).find('#cust-bulletin-board').html();
              $('#cust-bulletin-board').html(content);
            }
          });
      }
    // function addhidden(){
    //     $('.show-more-btn').on('click', function() {
    //        $('.cart-item').slice(4).toggleClass('hidden');
    //     });
    // }

let expanded = false;

function moreLess() {
    const $btn = $('#CartViewMoreBtn');
    const totalQty = parseInt($btn.attr('totalQty')) || 0;
    const $items = $('.cart-item');

    if (!expanded) {
        // SHOW ALL except first 4 already visible
        $items.removeClass('hidden');

        $btn.text('Show less');
        expanded = true;

    } else {
        // HIDE all items after first 4
        $items.each(function (index) {
            if (index >= 4) {
                $(this).addClass('hidden');
            }
        });

        // Remaining items count
        const remaining = totalQty - 4;

        if (remaining > 0) {
            $btn.text(remaining + ' more items');
        } else {
            $btn.hide(); // optional if <=4 items
        }

        expanded = false;
    }
}

    // function initCartViewMore() {
    //   const items = document.querySelectorAll('.cart-item-row');
    //   const btn = document.getElementById('CartViewMoreBtn');

    //   if (!btn || items.length <= 4) return;

    //   let expanded = false;

    //   function updateItems() {
    //     items.forEach((item, index) => {
    //       if (!expanded && index > 3) {
    //         item.classList.add('hidden-item');
    //       } else {
    //         item.classList.remove('hidden-item');
    //       }
    //     });
    //   }

    //   updateItems();

    //   btn.addEventListener('click', function () {
    //     expanded = !expanded;

    //     if (expanded) {
    //       btn.innerText = 'Show less';
    //     } else {
    //       btn.innerText = items.length - 4 + ' more items';
    //     }

    //     updateItems();
    //   });
    // }




    /************************************************ */
    


    document.querySelectorAll('.product__accordion details')
    .forEach(detail => {
      const summary = detail.querySelector('summary');
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      detail.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      });
    });